import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { ClipboardCheck } from "lucide-react";
import { toast } from "sonner";

export function CheckEmailCard() {
  const [cfg, setCfg] = useState(null);
  const [email, setEmail] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get("/vehicle-checks/admin/notify-config").then(r => { setCfg(r.data); setEmail(r.data.email || r.data.default_email || ""); }).catch(() => setCfg(null));
  }, []);
  if (!cfg) return null;
  const save = async () => {
    setSaving(true);
    try {
      const r = await api.put("/vehicle-checks/admin/notify-config", { email: email.trim() === cfg.default_email ? "" : email.trim() });
      setCfg(r.data); toast.success("Destinatario salvato");
    } catch (e) { toast.error(formatApiError(e)); }
    setSaving(false);
  };
  return (
    <div className="rounded-2xl border border-amber-500/25 bg-gradient-to-b from-[#0F0D09] to-[#070605] p-4 space-y-3" data-testid="check-email-card">
      <div className="flex items-center gap-2"><ClipboardCheck size={18} className="text-amber-400" /><div className="font-display text-lg font-extrabold text-white">Email notifiche controlli veicolo</div></div>
      <div className="text-xs text-slate-400">Riceve un'email per ogni controllo completato (Tutto OK, segnalazioni, controlli incompleti) e per ogni segnalazione libera degli autisti. Lascia vuoto per usare l'email dell'account amministratore{cfg.default_email ? ` (${cfg.default_email})` : ""}.</div>
      <div className="flex flex-col sm:flex-row gap-2">
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder={cfg.default_email || "email@azienda.it"} data-testid="check-email-input"
          className="h-10 flex-1 rounded-lg bg-slate-950 border border-slate-800 text-sm text-slate-200 px-3 focus:border-amber-500/60 outline-none" />
        <button type="button" onClick={save} disabled={saving} data-testid="check-email-save"
          className="h-10 rounded-lg px-4 text-sm font-bold text-black bg-gradient-to-b from-[#F1D27A] to-[#C99A24] disabled:opacity-60">Salva</button>
      </div>
      <div className="text-[11px] text-slate-500" data-testid="check-email-effective">Destinatario attuale: {cfg.effective || "nessuno"}</div>
    </div>
  );
}
